import './App.css';
import { Header } from './Modules/Templates/Header';
import { Home } from './Modules/Home/Home';
import { Footer } from './Modules/Templates/Footer';
import { Builder } from './Modules/Builder/Builder';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { Features } from './Modules/Features/Features';
import { Results } from './Modules/Results/Results';
import { Builderold } from './Modules/Builder/Builderold';
import { Input, Modal } from 'antd';
import { useState } from 'react';

function App() {
 
  return (
    <div className="App">
      <BrowserRouter>
      <Header/>
        <Routes>
            <Route path="/builder" element={<Builder />} />
            <Route path="/builderold" element={<Builderold />} />
            <Route path="/features" element={<Features  />} />
            <Route path="/results" element={<Results  />} />
            <Route path="/*" element={<Home  />} />
        </Routes>
      <Footer/>
      </BrowserRouter>

      
    </div>
  );
}

export default App;
